export default "__VITE_PUBLIC_ASSET__90bb9318__"